import { render, staticRenderFns } from "./SurveyQuestionChildren.vue?vue&type=template&id=dab44132&"
import script from "./SurveyQuestionChildren.vue?vue&type=script&lang=ts&"
export * from "./SurveyQuestionChildren.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports